<template>
  <div class="box">
    <h3 class="title is-4">Reimbursement Estimates</h3>
    <div class="content">
      <p>
        Get detailed Out of Network reimbursement percentage estimates across different levels of
        care based on historical data from BCBS and other major payers. Make informed financial
        decisions for your treatment programs.
      </p>

      <h4>How It Works:</h4>
      <ul>
        <li>
          <strong>BCBS Flow:</strong>
          Start by entering a prefix (e.g., XYZ) to see estimates for Blue Cross Blue Shield plans
        </li>
        <li>
          <strong>Other Payers Flow:</strong>
          Select a payer name to view estimates for non-BCBS insurance providers
        </li>
        <li>
          <strong>Optional Filters:</strong>
          Refine your results by adding a group number or employer name for more accurate estimates
        </li>
      </ul>

      <h4>Coverage Levels:</h4>
      <ul>
        <li>
          <strong>Detox (DTX):</strong>
          Detoxification services reimbursement rates
        </li>
        <li>
          <strong>Residential (RTC):</strong>
          Residential treatment center coverage
        </li>
        <li>
          <strong>Partial Hospitalization (PHP):</strong>
          Day treatment program rates
        </li>
        <li>
          <strong>Intensive Outpatient (IOP):</strong>
          Intensive outpatient program coverage
        </li>
        <li>
          <strong>Outpatient (OP):</strong>
          Standard outpatient therapy reimbursement
        </li>
      </ul>

      <h4>Key Benefits:</h4>
      <ul>
        <li>Historical data from real claims</li>
        <li>Percentage allowed on charges (excludes co-insurance)</li>
        <li>Instant results with automatic updates</li>
        <li>Filter by specific criteria for targeted estimates</li>
        <li>Compare rates across different treatment levels</li>
      </ul>

      <div class="notification is-info is-light mt-4">
        <p>
          <strong>Important Note:</strong>
          These estimates are based on historical data and represent percentage allowed on charges.
          Actual reimbursement may vary based on specific plan details, deductibles, co-insurance,
          and other factors at time of claim submission.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReimbursementFeatureDetail',
};
</script>

<style scoped>
.content h4 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #363636;
}

.content ul {
  margin-top: 0.5rem;
}

.content li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.content li strong {
  color: #363636;
}

.notification {
  border-left: 4px solid #3273dc;
}
</style>
